export default __webpack_public_path__ + "locales/si/PaymentsEnterprise.json?hash=312c4dc719de1ee6459019c7561de34e";